import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

export type BrowserHistory = typeof browserHistory;

export default browserHistory;
